'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SearchData = /*#__PURE__*/ function() {
    function SearchData() {}
    SearchData.toHelpCenterItems = function toHelpCenterItems(data) {
        return data ? data.map(function(entry) {
            var _ref = entry.data || {}, likeCount = _ref.likeCount, sumLikes = _ref.sumLikes;
            return _extends({}, entry, {
                id: entry.url,
                link: {
                    url: entry.url
                },
                hint: entry.likes || sumLikes || likeCount,
                title: entry.description || entry.title
            });
        }) : [];
    };
    SearchData.toSearchNavigationItems = function toSearchNavigationItems(data) {
        return data ? data == null ? void 0 : data.map(function(entry) {
            var _ref = entry.data || {}, category = _ref.category, categoryTitle = _ref.categoryTitle;
            return _extends({}, entry, {
                id: entry.url,
                link: {
                    url: entry.url
                },
                hint: categoryTitle || (category == null ? void 0 : category.title)
            });
        }) : [];
    };
    return SearchData;
}();

export { SearchData };
